import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { Tooltip } from '@material-ui/core'
import isBoolean from 'lodash/isBoolean'
import isEmpty from 'lodash/isEmpty'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import { DATE_FORMAT_US_LONG } from '../../../../../constants'

dayjs.extend(utc)

const mapExceptionNotes = (exceptionFootnote, rowOriginal) => {
  return Object.entries(exceptionFootnote).reduce(
    (acc, [exceptionNoteKey, exceptionNoteValues]) => {
      if (rowOriginal?.[exceptionNoteKey] === undefined) return acc

      const exceptionNote = exceptionNoteValues[rowOriginal[exceptionNoteKey]]
      acc.push(exceptionNote)
      return acc
    },
    []
  )
}

const HoldingPeriodReturnCell = ({ column, value, row }) => {
  const { highlightSymbol, tooltipTitle, valueFormatted } = useMemo(() => {
    const { parent, payload, formatter, format } = column

    const rowOriginal = row?.original?.[parent?.id]
    const notHeldEntirePeriod = Boolean(rowOriginal && !rowOriginal?.heldEntirePeriod)
    const valueFormatted = formatter ? formatter(value, format) : value

    const {
      highlightSymbol,
      exceptionFootnote,
      showSymbolWhenNotHeldEntirePeriod
    } = payload || {}

    const placeholderSymbol = !isBoolean(showSymbolWhenNotHeldEntirePeriod)
      ? showSymbolWhenNotHeldEntirePeriod
      : '-'

    let tooltipTitle = []

    if (exceptionFootnote) {
      tooltipTitle = tooltipTitle
        .concat(mapExceptionNotes(exceptionFootnote, rowOriginal))
        .filter(Boolean)

      if (!isEmpty(tooltipTitle) && rowOriginal?.firstDataAvailable) {
        tooltipTitle = [
          `Start Date ${dayjs
            .utc(rowOriginal?.firstDataAvailable)
            .format(DATE_FORMAT_US_LONG)}`,
          ...tooltipTitle
        ]
      }
    }

    return {
      highlightSymbol:
        (notHeldEntirePeriod || exceptionFootnote) && !isEmpty(tooltipTitle)
          ? highlightSymbol || '*'
          : '',
      valueFormatted: showSymbolWhenNotHeldEntirePeriod && notHeldEntirePeriod
        ? placeholderSymbol
        : valueFormatted,
      tooltipTitle: tooltipTitle.join('\n')
    }
  }, [column, row?.original, value])

  if (!value && !row) {
    return column.header
  }

  if (tooltipTitle) {
    return (
      <Tooltip
        title={<div style={{ whiteSpace: 'pre-line' }}>{tooltipTitle}</div>}
      >
        <span>
          {valueFormatted}
          {highlightSymbol}
        </span>
      </Tooltip>
    )
  }

  return (
    <span>
      {valueFormatted}
      {highlightSymbol}
    </span>
  )
}

HoldingPeriodReturnCell.propTypes = {
  value: PropTypes.oneOf([PropTypes.string, PropTypes.number]),
  row: PropTypes.object,
  column: PropTypes.shape({
    parent: PropTypes.object,
    header: PropTypes.string,
    format: PropTypes.string,
    payload: PropTypes.object,
    formatter: PropTypes.func,
    cellTooltipTitle: PropTypes.string
  })
}

export default HoldingPeriodReturnCell
